"use client";

import { useInfront } from "@/context/infront-context";
import {
  createInstrumentSlug,
  DEFAULT_CONTENT,
} from "@/services/infront/utils";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

type RelatedIndicatorListProps = {
  instruments: { feed: number; ticker: string }[];
  title?: string;
};

const RelatedIndicatorList = (props: RelatedIndicatorListProps) => {
  const ID = `indicator-list-${uuidv4()}`;

  const router = useRouter();
  const { isReady, load } = useInfront();
  useEffect(() => {
    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(
      () => {
        if (isReady) {
          const widgetOptions = new window.Infront.QuoteListWidgetOptions();

          widgetOptions.onInstrumentSelected = (instrument: {
            feed: number;
            ticker: string;
          }) => {
            router.push(
              createInstrumentSlug(instrument.feed, instrument.ticker),
            );
          };

          widgetOptions.instruments = props.instruments;
          widgetOptions.defaultContent = DEFAULT_CONTENT;
          widgetOptions.enableChangeStatusColors = true;

          widgetOptions.columns = [
            {
              name: "FULL_NAME",
              flag: true,
            },
            "LAST",
            "PCT_CHANGE",
            "ONE_W_PCT_CHANGE",
            "YTD_PCT_CHANGE",
            "ONE_Y_PCT_CHANGE",
            "FIVE_Y_PCT_CHANGE",
            "TIME",
          ];

          const widget = window.infront.quoteList(`#${ID}`, widgetOptions);

          return () => {
            widget.destroy();
          };
        }
      },
    );
  }, [isReady, router, props.instruments]);

  return <div className="card bg-transparent indicator-list" id={ID} />;
};

export default RelatedIndicatorList;
